<template>
  <b-modal :id="id" hide-header hide-footer centered>
    <div class="text-center p-3">
      <p v-for="(m,i) in messages" :key="i" :class="getMainMsgClass(i)">
        <strong>{{ m }}</strong>
      </p>

      <div class="d-flex justify-content-center">
        <b-button variant="outline-danger" class="mr-3" @click="cancel">
          {{ cancelMsg }}
        </b-button>
        <b-button variant="outline-success" @click="ok">
          {{ okMsg }}
        </b-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  name : "confirmationBox",
  props: {
    id       : String,
    show     : Boolean,
    mainMsg  : {
      type   : [String, Array],
      default: "Êtes-vous sûr?"
      //TODO string array validator ?
    },
    cancelMsg: {
      type   : String,
      default: "Annuler"
    },
    okMsg    : {
      type   : String,
      default: "Confirmer"
    },
  },
  data() {
    const {mainMsg} = this.$props
    const messages  = typeof mainMsg === "string" ? [mainMsg] : mainMsg
    return {
      messages
    }
  },
  methods: {
    getMainMsgClass(i) {
      const last = this.$data.messages.length - 1;
      return i !== last ? "mb-0" : ""
    },
    ok($event) {
      this.$emit('ok', $event.target.checked);
      this.$bvModal.hide(this.id)
    },
    cancel($event) {
      this.$emit('cancel', $event.target.checked);
      this.$bvModal.hide(this.id)
    },
  }

}
</script>

<style scoped>

</style>